import { runInAction, makeObservable, observable, action, computed } from "mobx";
import { getSuggestions } from "../services/getLearningItemService";

class AutoCompleteStore {
  activeIndex = -1;
  data = [];
  keyword = "";
  isFocused = false;

  constructor() {
    makeObservable(this, {
      data: observable,
      keyword: observable,
      isFocused: observable,
      activeIndex: observable,
      isShow: computed,
      load: action,
      clear: action,
      updateKeyword: action,
      updateIsFocused: action,
      updateActiveIndex: action
    });
  }

  updateKeyword = value => {
    this.keyword = value;
  };

  updateIsFocused = value => {
    this.isFocused = value;
  };

  updateActiveIndex = value => {
    this.activeIndex = value;
  };

  calculateNextIndex = keyIdentity => {
    const len = this.data.length;
    // up arrow
    if (keyIdentity === 38) {
      if (this.activeIndex === -1 || this.activeIndex === 0) return len - 1;
      return this.activeIndex - 1;
    }
    // down arrow
    if (keyIdentity === 40) {
      if (this.activeIndex === -1 || this.activeIndex === len - 1) return 0;
      return this.activeIndex + 1;
    }

    return -1;
  };

  load = async (tag, keyword) => {
    try {
      const rlt = await getSuggestions(tag, keyword);
      runInAction(() => {
        this.data = rlt.data;
        this.activeIndex = -1;
      });
    } catch {
      console.log("Error loading auto complete suggestions");
    }
  };

  clear = () => {
    this.data = [];
    this.activeIndex = -1;
  };

  getKeywordByActiveIdx = () => {
    const kw = this.data[this.activeIndex];
    this.updateKeyword(kw);
    this.clear();
    return kw;
  };

  get isShow() {
    return this.data.length > 0 && this.isFocused;
  }
}

const store = new AutoCompleteStore();
export default store;
export { AutoCompleteStore };
